import { render, staticRenderFns } from "./SaleAttribute.vue?vue&type=template&id=1c1a7c4d&scoped=true&"
import script from "./SaleAttribute.vue?vue&type=script&lang=js&"
export * from "./SaleAttribute.vue?vue&type=script&lang=js&"
import style0 from "./SaleAttribute.vue?vue&type=style&index=0&id=1c1a7c4d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1a7c4d",
  null
  
)

export default component.exports